export function collect<T>(val1: T[], val2: T[]) {
    return [...val1, ...val2]
}